import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { ROUTE_PATHS } from 'router/routes'

import { ProvidersType } from 'modules/SlotsRoot/types/configuration'

import { getFreeSpinInfo } from 'features/slots/actions'

import { usePoll } from './usePoll'

export const useFreeSpinInfoPolling = (enabled: boolean) => {
  const dispatch = useDispatch()
  const match = useRouteMatch<{ provider: ProvidersType }>(ROUTE_PATHS.SLOTS_PROVIDER_FREE_SPIN)

  const getFreeSpinInfoFunc = async () => {
    if (match?.params.provider) {
      dispatch(getFreeSpinInfo({ provider: match.params.provider }))
    }
  }

  usePoll(enabled ? getFreeSpinInfoFunc : async () => {}, { delay: 5 })

  return null
}
